import { LOOPS_ARTICLE } from '@/lib/site/seo/integration-articles/loops'
import { ProseSection } from '../[provider]/prose-section'

export function LoopsExportGuide() {
  return (
    <>
      {LOOPS_ARTICLE.sections.map((section) => (
        <ProseSection key={section.heading} title={section.heading}>
          <div className="flex flex-col gap-3">
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </div>
        </ProseSection>
      ))}
      <ProseSection title="Guides and setup">
        <ul className="flex flex-col gap-2">
          {LOOPS_ARTICLE.sources.map((source) => (
            <li key={source.url}>
              <a
                href={source.url}
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-4"
              >
                {source.title}
              </a>
            </li>
          ))}
        </ul>
      </ProseSection>
    </>
  )
}
